<ng-template #helpTemplate> <div #template [innerHtml]="helpHtml"></div></ng-template>

<!-- cascading over card body -->
<div *ngIf="!isStandalone" class="view view-cascade overlay rtr-background-green-bold pl-3 py-2 white-text " 
    [mdbTooltip]="helpTemplate" [triggers]="helpTriggers"
>
    <span [ngClass]="{ 'mb-0': true, 'h1': vm.headingSize == 1, 'h2': vm.headingSize == 2, 'h3': vm.headingSize == 3, 'h4': vm.headingSize == 4, 'h5': vm.headingSize == 5 }"
    >{{vm.titleText}}</span>            
    <app-form-help *ngIf="helpShow" [html]="undefined"></app-form-help>    

    <span *ngIf="!vm.subTitleSmall">{{vm.subTitleText}}</span>

    <small *ngIf="vm.subTitleSmall">{{vm.subTitleText}}</small>
</div>

<!-- standalone with no card body -->
<div *ngIf="isStandalone" style="border-radius: 4px;" class="text-center view overlay gradient-card-header rtr-background-green-bold py-2 px-5 white-text"
    [mdbTooltip]="helpTemplate" [triggers]="helpTriggers"
>
    <span [ngClass]="{ 'mb-0': true, 'h1': vm.headingSize == 1, 'h2': vm.headingSize == 2, 'h3': vm.headingSize == 3, 'h4': vm.headingSize == 4, 'h5': vm.headingSize == 5 }"
    >{{vm.titleText}}</span>            
    <app-form-help *ngIf="helpShow" [html]="undefined"></app-form-help>    

    <span *ngIf="!vm.subTitleSmall">{{vm.subTitleText}}</span>

    <small *ngIf="vm.subTitleSmall">{{vm.subTitleText}}</small>
</div>
